module.exports = __webpack_public_path__ + "img/6.83ee9f1e.png";